import { f as r } from "./function-name.js";
import { f as s } from "./fails.js";
import { w as n } from "./whitespaces.js";
var o = r.PROPER,
  t = "​\x85᠎",
  i = function i(r) {
    return s(function () {
      return !!n[r]() || t[r]() !== t || o && n[r].name !== r;
    });
  };
export { i as s };